import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const createApiError = (error) => {
    const message = error.response?.data?.message || error.message || 'Request failed';
    const apiError = new Error(message);
    apiError.status = error.response?.status;
    apiError.data = error.response?.data;
    apiError.originalError = error;
    return apiError;
};

const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
    };
};

export const getWishlist = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/appUser/wishlist`, getAuthConfig());
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const addWishlistItem = async (menuItemId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/appUser/wishlist/${menuItemId}`,
            {},
            getAuthConfig()
        );
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const removeWishlistItem = async (menuItemId) => {
    try {
        const response = await axios.delete(`${API_URL}/api/appUser/wishlist/${menuItemId}`, getAuthConfig());
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};

export const clearWishlistItems = async () => {
    try {
        const response = await axios.delete(`${API_URL}/api/appUser/wishlist`, getAuthConfig());
        return response.data;
    } catch (error) {
        throw createApiError(error);
    }
};
